import { render, staticRenderFns } from "./BrandAccount.vue?vue&type=template&id=2513ea02&scoped=true"
import script from "./BrandAccount.vue?vue&type=script&lang=js"
export * from "./BrandAccount.vue?vue&type=script&lang=js"
import style0 from "./BrandAccount.vue?vue&type=style&index=0&id=2513ea02&prod&scoped=true&lang=scss"
import style1 from "./BrandAccount.vue?vue&type=style&index=1&id=2513ea02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2513ea02",
  null
  
)

export default component.exports